module.exports = __webpack_public_path__ + "fk.svg?1bffbf9fdbc7e06d1e4ea685247c72f5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/fk.svg
// module id = 1098
// module chunks = 0